import { createSlice } from '@reduxjs/toolkit';

// Persists per-listing UI state (page, filters, search) keyed by a module name,
// so returning to a list after add/edit/view restores where the user was.
// In-memory only (per browser tab) — cleared on Reset Filter.
const listStateSlice = createSlice({
    name: 'listState',
    initialState: {},
    reducers: {
        // save/overwrite the whole state blob for one module
        setListState(state, action) {
            const { key, value } = action.payload;
            state[key] = value;
        },
        // drop a module's saved state (e.g. on Reset Filter)
        clearListState(state, action) {
            delete state[action.payload];
        },
    },
});

export const { setListState, clearListState } = listStateSlice.actions;
export default listStateSlice.reducer;
